var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/HouseWithDollarSign.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var HouseWithDollarSign = function HouseWithDollarSign(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    width: "44",
    height: "44",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 9
    }
  }, "Dollar House"), /*#__PURE__*/React.createElement("path", {
    d: "m19.919 4c-0.3713-0.00484-0.7323 0.12199-1.019 0.358l-13.881 13.191c-0.60957 0.586-0.9738 1.3817-1.019 2.226v20.868c-4e-3 0.3559 0.13357 0.6989 0.38243 0.9534 0.24887 0.2545 0.58865 0.3997 0.94457 0.4036h29.184c0.3559-0.0039 0.6957-0.1491 0.9446-0.4036 0.2488-0.2545 0.3864-0.5975 0.3824-0.9534v-20.868c-0.0452-0.8443-0.4094-1.64-1.019-2.226l-13.881-13.191c-0.2868-0.23586-0.6477-0.36267-1.019-0.358z",
    fill: "#A6E5FF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.906 2.339c0.2797-0.22405 0.6286-0.3439 0.987-0.339 0.3586-0.00471 0.7078 0.1151 0.988 0.339l13.453 12.497c0.5885 0.5496 0.9424 1.3051 0.988 2.109v19.769c0 0.7103-0.5758 1.286-1.286 1.286h-28.286c-0.341 0-0.668-0.1355-0.90899-0.3767-0.24101-0.2412-0.37628-0.5683-0.37601-0.9093v-19.766c0.04518-0.804 0.39913-1.5596 0.988-2.109l13.453-12.5zm13.678 14.381-12.691-11.788-12.695 11.792-0.051 0.047c-0.0478 0.0735-0.0851 0.1533-0.111 0.237v18.421h25.71v-18.425c-0.0259-0.0837-0.0632-0.1635-0.111-0.237l-0.051-0.047z",
    clipRule: "evenodd",
    fill: "#0D4599",
    fillRule: "evenodd",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "25.5",
    cy: "23.5",
    r: "8.5",
    fill: "#F2A619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.58 29.177v-0.6741c-1.4974-0.0371-2.842-0.8648-3.4675-2.1345-0.0717-0.1578-0.1099-0.327-0.1126-0.4983-0.0087-0.2738 0.1108-0.5377 0.3274-0.7227 0.2166-0.1851 0.5088-0.273 0.8005-0.2409 0.4902 0.0016 0.9299 0.2816 1.1102 0.7069 0.4089 0.8075 1.3313 1.275 2.28 1.1558 1.2905-0.0076 2.1093-0.4729 2.1093-1.3404 0-0.7145-0.7076-1.1002-1.9805-1.3721l-1.1522-0.2415c-2.0917-0.4413-3.4337-1.501-3.4337-3.0741 0.0525-1.7853 1.6102-3.2115 3.5245-3.2272v-0.6905c-0.0124-0.2901 0.1464-0.5633 0.4139-0.7118 0.2674-0.1485 0.6006-0.1485 0.868 0 0.2675 0.1485 0.4263 0.4217 0.4139 0.7118v0.6905c1.4737 0.0549 2.7748 0.9135 3.3211 2.1915 0.061 0.157 0.0931 0.3224 0.0949 0.4894 0 0.5222-0.4216 0.8434-1.0587 0.8434-0.4916 0.0093-0.9417-0.2559-1.1441-0.674-0.3524-0.7496-1.1836-1.2009-2.0564-1.1166-1.2308 0-1.9452 0.4983-1.9452 1.2772 0 0.6576 0.6981 1.0913 1.8341 1.324l1.0844 0.2327c2.2801 0.4742 3.5882 1.5086 3.5882 3.107 0 1.998-1.7039 3.1058-3.7169 3.322v0.6665c0.0124 0.2901-0.1464 0.5633-0.4139 0.7118s-0.6006 0.1485-0.8681 0c-0.2674-0.1485-0.4263-0.4217-0.4138-0.7118h-0.0068z",
    fill: "#F2FAFF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  }));
};

HouseWithDollarSign.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
HouseWithDollarSign.defaultProps = {
  className: null
};
export default HouseWithDollarSign;